import { Menu } from '@platform/shared/ui';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSessionContext } from '../../contexts/SessionContext';

interface Props {
  avatarClassNames?: string;
}

const UserMenu: React.FC<Props> = ({ avatarClassNames = '' }) => {
  const { user, logout } = useSessionContext();

  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <div className="hidden md:flex md:flex-shrink-0 md:items-center">
      <Menu
        visible={isOpen}
        onToggleVisibility={setIsOpen}
        trigger={
          <img
            className={`h-8 w-8 rounded-full border border-white ${avatarClassNames}`}
            src={user?.pictureSmallURL}
            alt={user?.firstName}
          />
        }
        hAlignment="right"
        menuMargin={12}
      >
        <div className="flex flex-col gap-1.5 py-1">
          <div className="px-4">
            <Link target="_blank" to={`${process.env.NX_ACCOUNTS_URL}/edit?context=geobuffer`}>
              Your Profile
            </Link>
          </div>
          <div className="cursor-pointer px-4" onClick={logout}>
            Sign Out
          </div>
        </div>
      </Menu>
    </div>
  );
};

export default UserMenu;
